/**
 * Whether the public landing shows real prices (FLOSEAI-673).
 *
 * Set to `false` to withdraw amounts from the public page while the pricing
 * strategy is being settled. The section keeps selling the product — plan
 * names, descriptions and the feature comparison stay — but every amount, the
 * billing-cycle toggle and the region selector are replaced by a "coming soon"
 * note, and the checkout call to action goes with them: a checkout button for a
 * price nobody can see is worse than no button.
 *
 * TO RESTORE PRICES: flip this to `true`. That is the whole change — nothing
 * was deleted, and `PricingSection` renders exactly what it rendered before.
 *
 * A constant rather than an environment variable on purpose: Expo inlines
 * `EXPO_PUBLIC_*` at build time, so an env var would still need a redeploy to
 * take effect while adding a way to get the state wrong through a typo. This is
 * one boolean, in source, covered by tests in both positions.
 */
export const PUBLIC_PRICING_VISIBLE = false;
